<div class="page-wrapper section-hr-direct">
    <app-left-menu></app-left-menu>
    <div id="main-container">
        <app-header [showAddClaim]="showAddClaim" [title]="title"></app-header>
        <div class="content-header"></div>
        <div class="page-content  " id="page-content">
            <div *ngIf="users?.length>0" style="font-style:italic">
                {{'Patients.Pharse1' |translate}}
                <br />
                <br />
                <div *ngIf="showAddClaim">
                    {{'Patients.Pharse2'|translate}}
                </div>
            </div>
            <div class="no-absolute m-t30">
                <div class="row">

                    <div class="col-md-10 col-md-push-1">

                        <div class="search-pan" *ngIf="users?.length>0">
                            <input style="height: 50px;" matInput #input
                                placeholder="{{'Common.Placeholder.PatientId' | translate}}" aria-label="State"
                                class="form-control patientid" [matAutocomplete]="auto" [formControl]="searchTerm">
                            <mat-autocomplete [displayWith]="displayFn" style="width: 280px;" #auto="matAutocomplete"
                                class="autoComplete">
                                <mat-option routerLinkActive="router-link-active"
                                    *ngFor="let user of filteredUser | async as users" [value]="user">

                                    <span aria-disabled="true" *ngIf="user.UserId==0">{{user.FullName}}</span>

                                    <a *ngIf="user.UserId>0" [routerLink]="['/claims/history',user.UserId]">
                                        <span>{{user.FullName}}</span> |
                                        <small>{{user.UserId}}</small></a>

                                </mat-option>

                            </mat-autocomplete>
                            <!-- <input type="text" placeholder="{{'Common.Search'|translate}}"
                                class="form-control oval-input" (keyup.enter)="getUsers()" [(ngModel)]="searchTerm">
                            <button type="submit" class="search-button" (click)="getUsers()"></button> -->
                        </div>
                    </div>
                </div>
                <div class="row m-t30">
                    <div class="col-md-10 col-md-push-1">
                        <div class="requests-list" *ngIf="users.length>0">
                            <ul class="pad_Left_0">
                                <li *ngFor="let u of users;">
                                    <div [routerLink]="['/claims/history',u.UserId]"
                                        routerLinkActive="router-link-active" class="request-item">
                                        <div style="float: left;" class="title">
                                            <a href="javascript:void(0)">
                                                {{u.FullName }}
                                            </a>
                                        </div>
                                        <div class="id">#{{u.UserId}}</div>
                                    </div>
                                </li>
                            </ul>

                        </div>

                        <div class="not-found" *ngIf="users?.length==0">
                            <div *ngIf="!showAddClaim">
                                {{showAddClaimMsg}}
                            </div>
                            <div *ngIf="showAddClaim">
                                {{'Patients.NotFound' |translate}}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>